import React from 'react'
import './footer.css'
const Footer = () => {
  return (
    <section id="footer" className='footer'>
      <span>Developed by Preeti Raj 2022 | It's inspired by many YouTube videos.</span>
  </section>
  )
}

export default Footer
